import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const { user, loading, isInitialized } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', {
    path: location.pathname,
    user: user?.email,
    role: user?.role,
    loading,
    isInitialized,
    allowedRoles
  });

  if (!isInitialized || loading) {
    console.log('ProtectedRoute: Still loading...');
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('ProtectedRoute: No user found, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && Array.isArray(allowedRoles)) {
    const userRole = typeof user.role === 'string'
      ? user.role.toLowerCase().replace(/\s+/g, '_')
      : (user.role?.name || '').toLowerCase().replace(/\s+/g, '_');
    const normalizedAllowedRoles = allowedRoles.map(
      r => r.toLowerCase().replace(/\s+/g, '_')
    );
    if (!normalizedAllowedRoles.includes(userRole)) {
      console.log(`ProtectedRoute: Role mismatch. User: ${userRole}, Allowed: ${normalizedAllowedRoles}`);
      return <Navigate to="/unauthorized" replace />;
    }
  }

  console.log('ProtectedRoute: Access granted');
  return children;
};

export default ProtectedRoute;
// ...existing code...